"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    deepCopy(arr) {
        return arr.map((row)=>row.slice());
    }
    constructor(initialState){
        const EMPTY_BOARD = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.board = initialState ? this.deepCopy(initialState) : this.deepCopy(EMPTY_BOARD);
        this.initialBoardState = this.deepCopy(this.board);
        this.score = 0;
        this.status = "idle";
        this.isStarted = false;
    }
    generateNewTile() {
        const emptyCells = [];
        for(let r = 0; r < 4; r++){
            for(let c = 0; c < 4; c++)if (this.board[r][c] === 0) emptyCells.push({
                row: r,
                col: c
            });
        }
        if (emptyCells.length === 0) return false;
        const randomIndex = Math.floor(Math.random() * emptyCells.length);
        const { row: row, col: col } = emptyCells[randomIndex];
        const newValue = Math.random() < 0.1 ? 4 : 2;
        this.board[row][col] = newValue;
        return true;
    }
    processLine(line) {
        let scoreChange = 0;
        let filtredLine = line.filter((value)=>value !== 0);
        for(let i = 0; i < filtredLine.length - 1; i++)if (filtredLine[i] === filtredLine[i + 1]) {
            filtredLine[i] *= 2;
            scoreChange += filtredLine[i];
            filtredLine[i + 1] = 0;
        }
        filtredLine = filtredLine.filter((value)=>value !== 0);
        while(filtredLine.length < 4)filtredLine.push(0);
        return {
            newLine: filtredLine,
            scoreChange: scoreChange
        };
    }
    transposeBoard(board) {
        const newBoard = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        for(let r = 0; r < 4; r++)for(let c = 0; c < 4; c++)newBoard[r][c] = board[c][r];
        return newBoard;
    }
    checkWin() {
        for(let r = 0; r < 4; r++)for(let c = 0; c < 4; c++){
            if (this.board[r][c] === 2048) {
                this.status = "win";
                return true;
            }
            const current = this.board[r][c];
            if (c < 3 && this.board[r][c + 1] === current) return true;
            if (r < 3 && this.board[r + 1][c] === current) return true;
        }
        return false;
    }
    hasAvailableMoves() {
        for(let r = 0; r < 4; r++)for(let c = 0; c < 4; c++){
            if (this.board[r][c] === 0) return true;
            const current = this.board[r][c];
            if (c < 3 && this.board[r][c + 1] === current) return true;
            if (r < 3 && this.board[r + 1][c] === current) return true;
        }
        return false;
    }
    checkGameStatus() {
        if (this.checkWin()) return;
        if (!this.hasAvailableMoves()) this.status = "lose";
    }
    moveLeft() {
        if (this.status !== "playing") return false;
        const oldBoard = this.deepCopy(this.board);
        let boardChange = false;
        for(let row = 0; row < 4; row++){
            const { newLine: newLine, scoreChange: scoreChange } = this.processLine(this.board[row]);
            this.score += scoreChange;
            if (oldBoard[row].join(",") !== newLine.join(",")) boardChange = true;
            this.board[row] = newLine;
        }
        if (boardChange) {
            this.generateNewTile();
            this.checkGameStatus();
            return true;
        }
        return false;
    }
    moveRight() {
        if (this.status !== "playing") return false;
        const oldBoard = this.deepCopy(this.board);
        let boardChanged = false;
        for(let row = 0; row < 4; row++){
            const line = this.board[row];
            line.reverse();
            const { newLine: newLine, scoreChange: scoreChange } = this.processLine(line);
            this.score += scoreChange;
            newLine.reverse();
            if (oldBoard[row].join(",") !== newLine.join(",")) boardChanged = true;
            this.board[row] = newLine;
        }
        if (boardChanged) {
            this.generateNewTile();
            this.checkGameStatus();
            return true;
        }
        return false;
    }
    moveUp() {
        if (this.status !== "playing") return false;
        const oldBoard = this.deepCopy(this.board);
        let boardChanged = false;
        this.board = this.transposeBoard(this.board);
        for(let row = 0; row < 4; row++){
            const { newLine: newLine, scoreChange: scoreChange } = this.processLine(this.board[row]);
            this.score += scoreChange;
            this.board[row] = newLine;
        }
        this.board = this.transposeBoard(this.board);
        for(let r = 0; r < 4; r++)if (oldBoard[r].join(",") !== this.board[r].join(",")) {
            boardChanged = true;
            break;
        }
        if (boardChanged) {
            this.generateNewTile();
            this.checkGameStatus();
            return true;
        }
        return false;
    }
    moveDown() {
        if (this.status !== "playing") return false;
        const oldBoard = this.deepCopy(this.board);
        let boardChanged = false;
        this.board = this.transposeBoard(this.board);
        for(let row = 0; row < 4; row++){
            const line = this.board[row];
            line.reverse();
            const { newLine: newLine, scoreChange: scoreChange } = this.processLine(line);
            this.score += scoreChange;
            newLine.reverse();
            this.board[row] = newLine;
        }
        this.board = this.transposeBoard(this.board);
        for(let r = 0; r < 4; r++)if (oldBoard[r].join(",") !== this.board[r].join(",")) {
            boardChanged = true;
            break;
        }
        if (boardChanged) {
            this.generateNewTile();
            this.checkGameStatus();
            return true;
        }
        return false;
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.board;
    }
    getStatus() {
        return this.status;
    }
    start() {
        this.generateNewTile();
        this.generateNewTile();
        this.status = "playing";
        this.isStarted = true;
    }
    restart() {
        this.board = this.initialBoardState.map((row)=>row.slice());
        this.score = 0;
        this.status = "idle";
        this.start();
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$gameField = document.querySelector(".game-field");
const $09e991522ca7e64e$var$startButton = document.querySelector(".button");
const $09e991522ca7e64e$var$scoreElement = document.querySelector(".game-score");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
function $09e991522ca7e64e$var$hideAllMessages() {
    $09e991522ca7e64e$var$messageStart.classList.add("hidden");
    $09e991522ca7e64e$var$messageWin.classList.add("hidden");
    $09e991522ca7e64e$var$messageLose.classList.add("hidden");
}
function $09e991522ca7e64e$var$updateBoard() {
    const boardState = $09e991522ca7e64e$var$game.getState();
    const cells = $09e991522ca7e64e$var$gameField.querySelectorAll(".field-cell");
    cells.forEach((cell, index)=>{
        const row = Math.floor(index / 4);
        const col = index % 4;
        if (!boardState[row] || boardState[row][col] === undefined) return;
        const value = boardState[row][col];
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell";
        if (value !== 0) cell.classList.add(`field-cell--${value}`);
    });
}
function $09e991522ca7e64e$var$updateScore() {
    $09e991522ca7e64e$var$scoreElement.textContent = $09e991522ca7e64e$var$game.getScore();
}
function $09e991522ca7e64e$var$updateStatus() {
    const st = $09e991522ca7e64e$var$game.getStatus();
    if ($09e991522ca7e64e$var$game.isStarted) {
        $09e991522ca7e64e$var$startButton.textContent = "Restart";
        $09e991522ca7e64e$var$startButton.classList.remove("start");
        $09e991522ca7e64e$var$startButton.classList.add("restart");
    } else {
        $09e991522ca7e64e$var$startButton.textContent = "Start";
        $09e991522ca7e64e$var$startButton.classList.add("start");
        $09e991522ca7e64e$var$startButton.classList.remove("restart");
    }
    $09e991522ca7e64e$var$hideAllMessages();
    if (st === "win") $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
    else if (st === "lose") $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
    else if (st === "idle") $09e991522ca7e64e$var$messageStart.classList.remove("hidden");
}
function $09e991522ca7e64e$var$updateUI() {
    $09e991522ca7e64e$var$updateBoard();
    $09e991522ca7e64e$var$updateScore();
    $09e991522ca7e64e$var$updateStatus();
}
function $09e991522ca7e64e$var$handleStartClick() {
    if ($09e991522ca7e64e$var$game.getStatus() === "playing" || $09e991522ca7e64e$var$game.isStarted) $09e991522ca7e64e$var$game.restart();
    else $09e991522ca7e64e$var$game.start();
    $09e991522ca7e64e$var$updateUI();
}
function $09e991522ca7e64e$var$handleKeyDown(e) {
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    let moved = false;
    switch(e.key){
        case "ArrowRight":
            moved = $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowLeft":
            moved = $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowUp":
            moved = $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            moved = $09e991522ca7e64e$var$game.moveDown();
            break;
        default:
            return;
    }
    if (moved) {
        e.preventDefault();
        $09e991522ca7e64e$var$updateUI();
    }
}
function $09e991522ca7e64e$var$init() {
    if (!$09e991522ca7e64e$var$startButton || !$09e991522ca7e64e$var$gameField || !$09e991522ca7e64e$var$scoreElement) return;
    $09e991522ca7e64e$var$startButton.addEventListener("click", $09e991522ca7e64e$var$handleStartClick);
    document.addEventListener("keydown", $09e991522ca7e64e$var$handleKeyDown);
    $09e991522ca7e64e$var$updateUI();
}
$09e991522ca7e64e$var$init();


//# sourceMappingURL=index.1b9e757c.js.map
